var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContactForm',{attrs:{"url":_vm.url,"business":_vm.business,"title":"Saada päring","asks-business-name":false,"can-attach-files":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }